import {
  notNullsy, notUndefined,
} from '~/_shared/utils/typeGuards';

// keeps only the entries whose value satisfies the given type guard, e.g. pickBy({ a: 1, b: undefined }, notUndefined) -> { a: 1 }
export const pickBy = <T extends object>(obj: Partial<T>, predicate: (value: Partial<T>[keyof T]) => boolean): Partial<T> =>
  Object.fromEntries(Object.entries(obj).filter(([, value]) => predicate(value as Partial<T>[keyof T]))) as Partial<T>;

// strips out keys whose value is null/undefined, e.g. { a: 1, b: null } -> { a: 1 }
export const removeNullsy = <T extends object>(obj: Partial<T>): Partial<T> => pickBy(obj, notNullsy);

// strips out keys whose value is undefined, e.g. { a: 1, b: undefined } -> { a: 1 }
export const removeUndefined = <T extends object>(obj: Partial<T>): Partial<T> => pickBy(obj, notUndefined);
